import { defineNuxtPlugin } from '#app'
import { useBrandTheme } from '~/domain/shared/branding/composables/useBrandTheme'

export default defineNuxtPlugin(() => {
  const { apply } = useBrandTheme()

  apply()
})
